import { Modal, Spin } from "antd";
import styles from "./styles.module.scss";

import {
  Activity,
  AttachFile,
  Attachments,
  Description,
  TicketDetailHeader,
} from "./components";
import { UseApiCallV2 } from "hooks";
import { useEffect, useState } from "react";
import { ModalCloseIcon } from "icons";

export const TicketDetailModalV1 = ({
  openTicketDetailModal,
  ticketData,
  refetchTicketsData,
  setOpenTicketDetailModal,
}) => {
  const {
    data: singleTicketData,
    isLoading: ticketDataLoading,
    refetch: refetchTicketDetail,
  } = UseApiCallV2({
    url: "/ticket_detail",
    method: "POST",
    skip: !openTicketDetailModal,
    paramsData: {
      ticket_id: ticketData?.ticket_id,
    },
  });

  const [totalMessages, setTotalMessages] = useState(
    singleTicketData?.messages
  );

  useEffect(() => {
    setTotalMessages(singleTicketData?.messages);
  }, [singleTicketData]);

  function handleCloseModal() {
    setOpenTicketDetailModal(false);
  }

  return (
    <Modal
      closeIcon={<ModalCloseIcon />}
      className={styles.userSubscriptionDetail}
      open={openTicketDetailModal}
      onCancel={handleCloseModal}
      footer={null}
      style={{
        maxWidth: "100%",
      }}
      centered
      styles={{
        body: {
          height: "95dvh",
        },
        content: {
          padding: "20px 20px 5px 20px",
        },
      }}
      width="79dvw"
      destroyOnClose={true}
    >
      <Spin spinning={ticketDataLoading}>
        <TicketDetailHeader
          ticketData={singleTicketData?.details}
          refetchTicketsData={refetchTicketsData}
          refetchTicketDetail={refetchTicketDetail}
        />
        <div
          style={{
            overflowY: "auto",
            height: "calc(95dvh - 65px)",
          }}
        >
          {/* <AttachFile /> */}
          <Description description={ticketData?.description} />
          {/* <Attachments /> */}
          <Activity
            singleTicketData={singleTicketData}
            totalMessages={totalMessages}
            setTotalMessages={setTotalMessages}
            ticketId={ticketData?.ticket_id}
          />
        </div>
      </Spin>
    </Modal>
  );
};
